import { createIcon } from '@chakra-ui/react';

export const CreditCardIcon = createIcon({
  displayName: 'CreditCardIcon',
  viewBox: '0 0 576 512',
  path: (
    <path
      d='M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z'
      fill='currentColor'
    />
  ),
});

<svg
  width='623'
  height='500'
  viewBox='0 0 623 500'
  fill='none'
  xmlns='http://www.w3.org/2000/svg'
>
  <g clip-path='url(#clip0_4_2)'>
    <circle
      cx='150'
      cy='150'
      r='126'
      transform='matrix(-1 0 0 1 300 200)'
      stroke='black'
      strokeWidth='48'
    />
    <path
      d='M47 384C47 419.3 75.7 448 111 448H120.71C82.041 436.986 52.6839 404.349 47 364.235V384ZM111 0C75.7 0 47 28.7 47 64V335.764C51.3383 305.148 69.467 278.888 95 263.271V192H575V384C575 392.8 567.8 400 559 400H239.731C226.563 423.031 204.579 440.512 178.29 448H559C594.3 448 623 419.3 623 384V64C623 28.7 594.3 0 559 0H111ZM455 304C441.7 304 431 314.7 431 328C431 341.3 441.7 352 455 352H503C516.3 352 527 341.3 527 328C527 314.7 516.3 304 503 304H455ZM263 304C256.043 304 249.8 306.929 245.425 311.624C250.29 323.423 252.978 336.322 252.999 349.838C256.04 351.226 259.426 352 263 352H375C388.3 352 399 341.3 399 328C399 314.7 388.3 304 375 304H263ZM559 48C567.8 48 575 55.2 575 64V96H95V64C95 55.2 102.2 48 111 48H559Z'
      fill='black'
    />
    <path
      d='M85 349.5L216 349.5'
      stroke='black'
      strokeWidth='36'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M150.5 415V284'
      stroke='black'
      strokeWidth='36'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </g>
  <defs>
    <clipPath id='clip0_4_2'>
      <rect
        width='623'
        height='500'
        fill='white'
        transform='matrix(-1 0 0 1 623 0)'
      />
    </clipPath>
  </defs>
</svg>;
